export const ADMIN_USERS_ROUTE = '/admin/users';
